import _ from 'lodash'

// types
import type { Widget } from 'types/asset'

export const getSortedWidgets = (widgetsConfigs?: Widget[]): Widget[] => {
  return _.sortBy(widgetsConfigs, ['layout.y', 'layout.x'])
}
